
import { Button } from '05-ui-kit';
import { useRouter } from '@nuxtjs/composition-api';
import { computed } from '@vue/composition-api';
interface Props {
  title?: string;
  description?: string;
  type?: 'review' | 'question';
}
const __sfc_main = {};
__sfc_main.props = {
  title: {
    key: "title",
    required: false,
    type: String
  },
  description: {
    key: "description",
    required: false,
    type: String
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'review'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const router = useRouter();
  const getButtonTitle = computed(() => {
    switch (props.type) {
      case 'review':
        return 'Написать отзыв';
      case 'question':
        return 'Задать вопрос';
      default:
        return null;
    }
  });
  function goToPage() {
    switch (props.type) {
      case 'review':
        return router.push({
          path: 'review/create/'
        });
      case 'question':
        return router.push({
          path: 'question/',
          query: {
            isActive: 'true'
          }
        });
      default:
        return null;
    }
  }
  return {
    getButtonTitle,
    goToPage
  };
};
__sfc_main.components = Object.assign({
  Button
}, __sfc_main.components);
export default __sfc_main;
